import React from 'react';
import { motion } from 'framer-motion';
import { useIsMobile } from '../hooks/useMediaQuery';

const Mission: React.FC = () => {
  const isMobile = useIsMobile();
  
  const MotionWrapper = ({ children, ...props }: any) => {
    if (isMobile) {
      return <div>{children}</div>;
    }
    return <motion.div {...props}>{children}</motion.div>;
  };
  
  return (
    <section id="mission" className="bg-[#F8F6F0] py-24">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-2 items-center">
          {/* Left side - Mountain illustration */}
          <MotionWrapper
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="flex justify-center lg:justify-start"
          >
            <div className="max-w-sm">
              <img 
                src="/assets/mountin climbing.png" 
                alt="Mountain climbing illustration" 
                className="w-full h-auto object-contain"
              />
            </div>
          </MotionWrapper>

          {/* Right side - Text content */}
          <MotionWrapper
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-left"
          >
            <MotionWrapper
              className="text-4xl md:text-5xl font-bold text-[#333333] mb-6"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <h2>Our Mission</h2>
            </MotionWrapper>
            
            <MotionWrapper
              className="text-xl md:text-2xl text-[#333333] leading-relaxed"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              <p>
                At Koral we are applying evolving technology to find solutions to real world problems. 
                Building innovative mobile and web applications, designing professional websites, and 
                providing comprehensive digital solutions in the B2B and B2C industries across 
                various niches utilizing new AI technologies.
              </p>
            </MotionWrapper>
          </MotionWrapper>
        </div>
      </div>
    </section>
  );
};

export default Mission;
